import * as React from 'react';
import { Wrapper } from '../SharedChatBubble.styled';
import { StyledImage, StyledImageChatBubble } from './ImageChatBubble.styled';
import { ChatBubbleStatus } from '../SharedChatBubbleStatus';
export const ImageChatBubble = ({ author, state, imageUrl, time = '', errorMessage = 'Message failed to send', width, height }) => {
    return (React.createElement(Wrapper, { author: author },
        React.createElement(StyledImageChatBubble, { "data-testid": "image-chat-bubble", author: author, state: state },
            React.createElement(StyledImage, { "data-testid": "image-chat-bubble-img", src: imageUrl, alt: `sent by ${author}`, width: width, height: height })),
        React.createElement(ChatBubbleStatus, { author: author, state: state, time: time, errorMessage: errorMessage })));
};
//# sourceMappingURL=ImageChatBubble.js.map